import { createSelector } from 'reselect';
import { SUCCESS } from '../fetchStatus';

export const UIkitSelector = state => state.UIkit;

export const isUIkitReadySelector = createSelector([UIkitSelector], UIkit => UIkit?.status === SUCCESS);
